import type {Theme} from '@material-ui/core/styles';
import {createStyles} from '@material-ui/core/styles';

export default createStyles((theme: Theme) => ({
    clientId: {
        color: theme.palette.primary.contrastText,
        opacity: 0.6,
        fontWeight: 'bold',
    },
}));
